module.exports = __webpack_public_path__ + "static/banner-home-purple-75a730b8916467e65ca8a7b6f395c9a0.png";